"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromInventory = exports.damageWall = exports.openDoor = exports.breakWindow = exports.tryMoveOffset = exports.damage = exports.showDamage = exports.getAt = exports.drawAll = exports.getAll = exports.runAll = exports.killAllButPlayer = exports.killAllEvenIncludingThePlayer = exports.kill = exports.pickupItem = exports.setPos = exports.getPlayer = exports.create = void 0;
var analytics_sidecar_1 = require("../../../engine/analytics-sidecar");
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueSpellUtils_1 = require("../anims/rogueSpellUtils");
var rogueDungeonFeatures_sidecar_1 = require("../items/rogueDungeonFeatures-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
require("../scene/rogueTester_7drl_2023-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueMonsters_sidecar_1 = require("./rogueMonsters-sidecar");
var rogueMonstersAi_1 = require("./rogueMonstersAi");
var rogueMonstersAi_sidecar_1 = require("./rogueMonstersAi-sidecar");
var rogueMonstersData_sidecar_1 = require("./rogueMonstersData-sidecar");
var rogueMonsters_playerCustomization_1 = require("./rogueMonsters_playerCustomization");
var _objs = [];
var _flashTimeMax = 0.5;
var _flashTime = 0;
var _flashMode = 0;
var create = function (type) {
    var data = rogueMonstersData_sidecar_1.rogueMonstersData.get(type);
    if (!data) {
        throw new Error('no data for monster type: ' + type);
    }
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image.scale = rogueDef_sidecar_1.rogueDef.scale;
    image.tint = data.color;
    var image2 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image2.scale = rogueDef_sidecar_1.rogueDef.scale;
    image2.visible = false;
    var image3 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image3.scale = rogueDef_sidecar_1.rogueDef.scale;
    image3.visible = false;
    var image4 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image4.scale = rogueDef_sidecar_1.rogueDef.scale;
    image4.visible = false;
    var imageStatus = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, sprites_sidecar_1.sprites.rogue50[0]);
    imageStatus.scale = rogueDef_sidecar_1.rogueDef.scale;
    var c = {
        x: 0,
        y: 0,
        char: '@',
        frames: sprites_sidecar_1.sprites.rogue10,
        image: image,
        image2: image2,
        image3: image3,
        image4: image4,
        imageStatus: imageStatus,
        isPlayer: data.isPlayer,
        isDead: false,
        data: data,
        hp: data.maxHp,
        maxHp: data.maxHp,
        ai: rogueMonstersAi_sidecar_1.rogueMonstersAi.create(data.aiMode),
        inventory: [],
        isSaved: false,
        isCaged: false,
        // level: 1,
        // exp: 0,
    };
    if (type === 'b') {
        c.isCaged = true;
    }
    // if (!data.canSleep && c.ai.state === EAiState.Sleep) {
    //   c.ai.state = EAiState.ChasePlayer
    // }
    _objs.push(c);
    return c;
};
exports.create = create;
var getPlayer = function () {
    return _objs.find(function (c) { return c.isPlayer; }) || null;
};
exports.getPlayer = getPlayer;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
    if (c.isPlayer) {
        var item = rogueItems_sidecar_1.rogueItems.getAt(x, y);
        if (item) {
            (0, exports.pickupItem)(c, item);
        }
        var feature = rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.getAt(x, y);
        if (feature) {
            rogueStats_sidecar_1.rogueStats.setMessage('You go down the stairs!');
            // rogueTester_7drl_2023.nextLevel()
        }
    }
};
exports.setPos = setPos;
var pickupItem = function (c, item) {
    rogueItems_sidecar_1.rogueItems.pickupItem(c, item);
};
exports.pickupItem = pickupItem;
var kill = function (c) {
    c.isDead = true;
    c.image.visible = false;
    c.image2.visible = false;
    c.image3.visible = false;
    c.image4.visible = false;
    c.imageStatus.visible = false;
};
exports.kill = kill;
var killAllEvenIncludingThePlayer = function () {
    _objs.forEach(function (c) {
        (0, exports.kill)(c);
    });
    cleanup();
};
exports.killAllEvenIncludingThePlayer = killAllEvenIncludingThePlayer;
var killAllButPlayer = function () {
    _objs.forEach(function (c) {
        if (!c.isPlayer) {
            (0, exports.kill)(c);
        }
    });
    cleanup();
};
exports.killAllButPlayer = killAllButPlayer;
var cleanup = function () {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(_objs, function (c) {
        c.image.destroy();
        c.image2.destroy();
        c.image3.destroy();
        c.image4.destroy();
        c.imageStatus.destroy();
    });
};
var runAll = function () {
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    _objs.forEach(function (c) {
        rogueMonstersAi_sidecar_1.rogueMonstersAi.run(c, map);
    });
    // Run fast monsters again
    _objs.forEach(function (c) {
        if (c.data.isFast) {
            rogueMonstersAi_sidecar_1.rogueMonstersAi.run(c, map);
        }
    });
};
exports.runAll = runAll;
var getAll = function () {
    return _objs;
};
exports.getAll = getAll;
var drawAll = function () {
    // let game = game2.getGame()
    cleanup();
    _flashTime += common_sidecar_1.common.getUpdateDelta();
    if (_flashTime > _flashTimeMax) {
        _flashTime = 0;
        _flashMode++;
    }
    var showStatus = _flashMode % 2 === 0;
    var useAscii = rogueStats_sidecar_1.rogueStats.useAscii();
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    _objs.forEach(function (c) {
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image, c);
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image2, c);
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image3, c);
        rogueDef_sidecar_1.rogueDef.moveTileOffset(c.image4, c.x, c.y, 0, -0.5);
        if (useAscii) {
            rogueDef_sidecar_1.rogueDef.moveTileOffset(c.imageStatus, c.x, c.y, 0, 0);
        }
        else {
            rogueDef_sidecar_1.rogueDef.moveTileOffset(c.imageStatus, c.x, c.y, -0.5, -0.5);
        }
        c.imageStatus.visible = false;
        c.imageStatus.tint = rogueDef_sidecar_1.rogueDef.colors.pureWhite;
        if (c.ai.state === rogueMonstersAi_1.EAiState.Sleep && c.data.canSleep) {
            if (useAscii) {
                spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, rogueMonofont_sidecar_1.rogueMonofont.getSprite('Z')[0]);
            }
            else {
                spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, sprites_sidecar_1.sprites.rogue50[0]);
            }
            c.imageStatus.visible = showStatus;
        }
        if (c.ai.isAlerted && c.data.canSleep) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, rogueMonofont_sidecar_1.rogueMonofont.getSprite('!')[0]);
            c.imageStatus.visible = showStatus;
        }
        if (c.isCaged) {
            rogueDef_sidecar_1.rogueDef.moveTileOffset(c.imageStatus, c.x, c.y, 0, 0);
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, rogueMonofont_sidecar_1.rogueMonofont.getSprite('#')[0]);
            c.imageStatus.tint = rogueDef_sidecar_1.rogueDef.colors.gray;
            c.imageStatus.visible = showStatus;
        }
        if (useAscii) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, rogueMonofont_sidecar_1.rogueMonofont.getSprite(c.data.char)[0]);
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, c.data.sprite[0]);
        }
        if (c.isPlayer) {
            (0, rogueMonsters_playerCustomization_1.setPlayerAppearance)(c);
        }
        else {
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, c.x, c.y);
            if (t) {
                if (c.data.isFriendly && c.isSaved) {
                    c.image.tint = rogueDef_sidecar_1.rogueDef.colors.darkBlue;
                }
                if (t.eVision === rogueMaps_1.EVision.Seen) {
                    c.image.visible = true;
                }
                else {
                    c.image.visible = false;
                    c.imageStatus.visible = false;
                }
            }
        }
    });
};
exports.drawAll = drawAll;
var getAt = function (x, y) {
    return _objs.find(function (c) { return c.x === x && c.y === y; }) || null;
};
exports.getAt = getAt;
function showDamage(x, y, type) {
    var t = rogueMaps_sidecar_1.rogueMaps.getTile(rogueMaps_sidecar_1.rogueMaps.getCurrentMap(), x, y);
    var damageTime = 0.33;
    if (t && t.eVision === rogueMaps_1.EVision.Seen) {
        if (type === 'fire') {
            rogueGlyphs_sidecar_1.rogueGlyphs.write(x, y, '*', rogueDef_sidecar_1.rogueDef.colors.orange, damageTime);
        }
        if (type === 'water') {
            rogueGlyphs_sidecar_1.rogueGlyphs.write(x, y, '*', rogueDef_sidecar_1.rogueDef.colors.lightBlue, damageTime);
        }
        if (type === 'cut') {
            rogueGlyphs_sidecar_1.rogueGlyphs.write(x, y, '*', rogueDef_sidecar_1.rogueDef.colors.red, damageTime);
        }
        if (type === 'smash') {
            rogueGlyphs_sidecar_1.rogueGlyphs.write(x, y, '*', rogueDef_sidecar_1.rogueDef.colors.brown, damageTime);
        }
        if (type === 'heal') {
            rogueGlyphs_sidecar_1.rogueGlyphs.write(x, y, '*', rogueDef_sidecar_1.rogueDef.colors.green, damageTime);
        }
    }
}
exports.showDamage = showDamage;
function damage(c, amount, type) {
    if (c.isDead) {
        return;
    }
    c.hp -= amount;
    showDamage(c.x, c.y, type);
    if (c.hp <= 0) {
        if (!c.isPlayer) {
            if (rogueMaps_sidecar_1.rogueMaps.isVisible(rogueMaps_sidecar_1.rogueMaps.getCurrentMap(), c.x, c.y)) {
                rogueStats_sidecar_1.rogueStats.setMessage("The ".concat(c.data.name, " dies!"));
            }
            if (c.data.isFriendly) {
                rogueStats_sidecar_1.rogueStats.addScore(-5);
            }
        }
        else {
            if (type === 'fire') {
                rogueStats_sidecar_1.rogueStats.setMessage("You burn to death!");
            }
            else {
                rogueStats_sidecar_1.rogueStats.setMessage("You die!");
            }
            analytics_sidecar_1.analytics.progressionFail('house' + rogueStats_sidecar_1.rogueStats.getStats().depth);
        }
        if (c.data.corpseItem) {
            var corpse = rogueItems_sidecar_1.rogueItems.create(c.data.corpseItem);
            rogueItems_sidecar_1.rogueItems.setPos(corpse, c.x, c.y);
        }
        (0, exports.kill)(c);
    }
    if (c.hp > c.data.maxHp) {
        c.hp = c.data.maxHp;
    }
}
exports.damage = damage;
function tryMoveOffset(c, ox, oy) {
    var x = c.x + ox;
    var y = c.y + oy;
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    var usedUpMove = false;
    if (map) {
        var tile = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
        if (tile) {
            var eTile = tile.eTile;
            var mAt = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
            if (mAt) {
                if (mAt.data.isFriendly) {
                    if (mAt.isCaged) {
                        mAt.isCaged = false;
                        rogueStats_sidecar_1.rogueStats.setMessage('You uncage the ' + mAt.data.name + '!');
                    }
                    else {
                        // Swap with friendly monster
                        rogueStats_sidecar_1.rogueStats.setMessage('You swap places with the ' + mAt.data.name);
                        var curX = c.x;
                        var curY = c.y;
                        rogueMonsters_sidecar_1.rogueMonsters.setPos(c, x, y);
                        rogueMonsters_sidecar_1.rogueMonsters.setPos(mAt, curX, curY);
                        usedUpMove = true;
                    }
                }
                else {
                    // Attack!
                    rogueStats_sidecar_1.rogueStats.setMessage('You attack the ' + mAt.data.name + '!');
                    if (mAt.data.isFire || mAt.data.isHellHound) {
                        var damage_1 = 1;
                        if (rogueStats_sidecar_1.rogueStats.getStats().waterHandsTimer > 0) {
                            damage_1 = 2;
                        }
                        (0, rogueSpellUtils_1.hurtFireAt)(x, y, damage_1);
                    }
                    else {
                        damage(mAt, 1, 'water');
                    }
                    usedUpMove = true;
                }
            }
            if (eTile === rogueMaps_1.ETile.Door) {
                (0, exports.openDoor)(map, x, y);
                rogueStats_sidecar_1.rogueStats.setMessage('You open the door');
                usedUpMove = true;
            }
            var showSmash = function () {
                showDamage(x, y, 'smash');
            };
            if (eTile === rogueMaps_1.ETile.Window) {
                (0, exports.breakWindow)(map, x, y);
                showSmash();
                // rogueStats.setMessage('You break the window!')
                // rogueMaps.setTile(
                //   map,
                //   x,
                //   y,
                //   ETile.WindowOpen,
                //   rogueDef.colors.dark,
                //   rogueDef.colors.lightBlue,
                // )
                // Chance of hurt self
                if (rando_sidecar_1.rando.chance(0.25)) {
                    rogueStats_sidecar_1.rogueStats.setMessage('You cut yourself!');
                    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
                    if (p) {
                        rogueMonsters_sidecar_1.rogueMonsters.damage(p, 1, 'cut');
                    }
                }
                usedUpMove = true;
            }
            if (eTile === rogueMaps_1.ETile.WallDamaged) {
                rogueStats_sidecar_1.rogueStats.setMessage('You break through the wall!');
                (0, exports.damageWall)(map, x, y);
                usedUpMove = true;
            }
            if (eTile === rogueMaps_1.ETile.Wall) {
                rogueStats_sidecar_1.rogueStats.setMessage('You damage the wall');
                (0, exports.damageWall)(map, x, y);
                usedUpMove = true;
            }
            if (!usedUpMove) {
                if (eTile === rogueMaps_1.ETile.Floor ||
                    eTile === rogueMaps_1.ETile.Corridor ||
                    eTile === rogueMaps_1.ETile.DoorOpen ||
                    eTile === rogueMaps_1.ETile.WindowOpen ||
                    eTile === rogueMaps_1.ETile.Grass ||
                    eTile === rogueMaps_1.ETile.WallBroken) {
                    (0, exports.setPos)(c, x, y);
                }
                else {
                    rogueStats_sidecar_1.rogueStats.setMessage('You bump into a wall.');
                }
            }
        }
    }
}
exports.tryMoveOffset = tryMoveOffset;
var breakWindow = function (map, x, y) {
    showDamage(x, y, 'smash');
    rogueStats_sidecar_1.rogueStats.setMessage('You break the window!');
    rogueMaps_sidecar_1.rogueMaps.setTile(map, x, y, rogueMaps_1.ETile.WindowOpen, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.lightBlue);
};
exports.breakWindow = breakWindow;
var openDoor = function (map, x, y) {
    var tile = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
    if (tile) {
        rogueMaps_sidecar_1.rogueMaps.setTile(map, x, y, rogueMaps_1.ETile.DoorOpen, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.brown, tile.variant);
    }
};
exports.openDoor = openDoor;
var damageWall = function (map, x, y) {
    var tile = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
    if (tile) {
        showDamage(x, y, 'smash');
        if (tile.eTile === rogueMaps_1.ETile.WallDamaged) {
            rogueStats_sidecar_1.rogueStats.tryDamageHouse(1);
            rogueMaps_sidecar_1.rogueMaps.setTile(map, x, y, rogueMaps_1.ETile.WallBroken, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.blueGray);
        }
        if (tile.eTile === rogueMaps_1.ETile.Wall) {
            rogueStats_sidecar_1.rogueStats.tryDamageHouse(1);
            rogueMaps_sidecar_1.rogueMaps.setTile(map, x, y, rogueMaps_1.ETile.WallDamaged, rogueDef_sidecar_1.rogueDef.colors.blueGray, rogueDef_sidecar_1.rogueDef.colors.dark);
        }
    }
};
exports.damageWall = damageWall;
var removeFromInventory = function (c, item) {
    assert_sidecar_1.assert.isIn(c.inventory, item);
    entitiesUtils_sidecar_1.entitiesUtils.remove(c.inventory, item);
    item.isInInventory = false;
};
exports.removeFromInventory = removeFromInventory;
